import { ref } from "vue";
import { useData } from "@/composables/useData";
const { sitedData } = useData();
import { payService } from "@/service/payService";
const orderData = ref({
    userInfo: "",           // 用户信息
    examId: 0,              // 考试ID
    phone: "",              // 手机号
    targetScore: 0,         // 目标分数
    targetExamTime: 0,      // 目标时间
    groupId: "",            // 课群ID
    groupTitle: "",         // 课群标题
    examTitle: "",          // 考试标题
    groupImg: "",           // 课群缩略图
    userId: "",             // 用户ID
    payId: "",              // 支付ID
    payQr: "",              // 支付二维码地址
    money: 0.0,             // 支付金额
    payStatus: 0,           // 支付状态
    taskStatus: 0,          // 任务状态
    targetDate: "",         // 目标完成时间
})
// 保存订单数据
const saveOrder = (orderObject, AuthorizationCode) => {
    return new Promise((resolve, reject) => {
        payService.save(sitedData.value.order.orderID, orderObject, AuthorizationCode).then(res => {
            if (res.data.result == true) {
                resolve(res.data.state);
            } else {
                reject(res.data.result);
            }
        }).catch(err => {
            reject(err);
        })
    })
}

export const useOrder = () => {
    return { orderData, saveOrder }
}
